import React from "react";
import { bool, func, instanceOf, oneOf, string } from "prop-types";

import {
  triggerConfirmationModalGA,
  triggerSaveDataGA
} from "../Analytics/analytics";
import {
  PersistentToastContainer,
  TimedToastContainer,
  ToastIcon,
  ToastText,
  ToastWrapper
} from "./styled";

class Toast extends React.Component {
  static defaultProps = {
    icon: "check",
    onToastClose: () => {},
    optionalStyles: {},
    timed: false
  };

  static propTypes = {
    /** A single word in an enum which indicates the font-awesome class
     * of icon which appears in the ToastIcon styled component.
     * Default value is "check". See propTypes below for
     * eligible values.
     */
    icon: oneOf(["check", "key", "star", "times", "heart"]),
    /**
     * Message which appears in Toast container
     */
    message: string.isRequired,
    /**
     * Function called when Toast times out, or is closed
     * by clicking on the "X" icon. Default value is
     * an empty function
     */
    onToastClose: func,
    /**
     * An object of css styles which is passed to the ToastContainer
     * styled component. This is necessary because ToastContainer is
     * position: fixed, and thus cannot be constrained by a wrapping
     * container.
     */
    optionalStyles: instanceOf(Object),
    /**
     * If true, the Toast will return a TimedDismissable component
     * that will linger for 6000 ms. If false, the Toast will
     * return a Dismissable component that the user must dispatch
     * with manually. Is false by default.
     */
    timed: bool
  };

  // GA starts
  componentDidMount() {
    triggerSaveDataGA();
    triggerConfirmationModalGA("open");
  }
  // GA ends

  render() {
    const { icon, message, onToastClose, optionalStyles, timed } = this.props;
    const ToastContainer = timed
      ? TimedToastContainer
      : PersistentToastContainer;
    return (
      <ToastWrapper data-test-id="authentication-toast">
        <ToastContainer onToggle={onToastClose} optionalStyles={optionalStyles}>
          <ToastIcon icon={icon} />
          <ToastText type="sm">{message}</ToastText>
        </ToastContainer>
      </ToastWrapper>
    );
  }
}

export default Toast;
